<script setup lang="ts">
import { TabsTrigger, type TabsTriggerProps } from "radix-vue";
import { cn } from "@/lib/utils";

const props = defineProps<TabsTriggerProps & { class?: string }>();
</script>

<template>
    <TabsTrigger
        v-bind="props"
        :class="
            cn(
                'rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-white focus-visible:ring-stone-950 data-[state=active]:bg-white data-[state=active]:text-stone-950 data-[state=active]:shadow-sm dark:ring-offset-stone-950 dark:focus-visible:ring-stone-300 dark:data-[state=active]:bg-stone-950 dark:data-[state=active]:text-stone-50 inline-flex items-center justify-center whitespace-nowrap transition-all focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50',
                props.class,
            )
        "
    >
        <slot />
    </TabsTrigger>
</template>
